import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getWaterfallAnalyses = asyncThunkWrapper({ 
  model: 'waterfallAnalyses', 
  action: 'getWaterfallAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', { input: ['id', 'filename'] }, 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/waterfall_flow/waterfall_analyses', { params });

    return response.data;
  } 
});
export const getWaterfallAnalysis = asyncThunkWrapper({ 
  model: 'waterfallAnalyses', 
  action: 'getWaterfallAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = [
      'id', 
      { input: ['id', 'filename', 'content_type', 'url'] }, 
      { first_result: ['id', 'filename', 'content_type', 'url'] }, 
      { second_result: ['id', 'filename', 'content_type', 'url'] },
      'status', 
      'updated_at'
    ];
    const params = { attributes };
    const response = await axios.get(`/waterfall_analyses/${id}`, { params });
      
    return { data: response.data, cable };
  } 
});
export const createWaterfallAnalysis = asyncThunkWrapper({ 
  model: 'waterfallAnalyses', 
  action: 'createWaterfallAnalysis', 
  func: async (waterfall_analysis) => {
    const attributes = ['id', { input: ['id', 'filename'] }, 'status', 'updated_at'];
    const response = await axios.post(`/waterfall_flow/waterfall_analyses`, { waterfall_analysis, attributes });

    return response.data;
  } 
});
export const clearLocalWaterfallAnalyses = createAction('waterfallAnalyses/clearLocalWaterfallAnalyses');
export const clearLocalActiveWaterfallAnalysis = createAction('waterfallAnalyses/clearLocalActiveWaterfallAnalysis');